import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Metatags from '../../components/Metatags/Metatags';
import Schedule from '../../endpoints/Schedule/Schedule';
import {
  fetchMemberDriveStatus,
  addMemberDriveElements,
} from '../../utils/membershipUtils';
import { daysofweek } from '../../server/daysofweek';
import adCleanup from '../../utils/adCleanup';
import fetchSchedule from '../api/schedule/fetchSchedule';

const SchedulePage = ({ schedule, errorCode }) => {
  if (!schedule || errorCode) return <ErrorPage statusCode={404} />;
  useEffect(() => {
    fetchMemberDriveStatus().then((data) => {
      addMemberDriveElements(data);
    });
  }, []);

  return (
    <>
      <Metatags fullSlug="schedule" title="Schedule" />
      <Schedule schedule={schedule} />
    </>
  );
};

export async function getServerSideProps({ res }) {
  const dte = new Date();
  const dayofweekIdx = dte.getDay();
  const day = daysofweek()[dayofweekIdx];

  const props = await fetchSchedule(day);

  if (res) {
    const errorCode = res.statusCode > 200 ? res.statusCode : false;
    res.setHeader('Cache-Control', 'public, max-age=60');
    return {
      props: {
        schedule: {
          props,
          day,
        },
        errorCode,
      },
    };
  }

  adCleanup();
  return {
    props: {
      schedule: {
        props,
        day,
      },
    },
  };
}

SchedulePage.propTypes = {
  schedule: PropTypes.object,
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default SchedulePage;
